import { getNoteAtPosition, type NeckPosition } from "../guitarEngine";
import type { FretPosition } from "./types";

export function fretPositionsToNeck(
  positions: FretPosition[],
  highlight: NeckPosition["highlight"] = "active",
): NeckPosition[] {
  return positions.map(({ string, fret }) => {
    const { note } = getNoteAtPosition(string, fret);
    return { string, fret, note, highlight };
  });
}

export function gymMutedStrings(visibleStrings: number[]): number[] {
  const all = [1, 2, 3, 4, 5, 6];
  return all.filter((s) => !visibleStrings.includes(s));
}

export function fretPositionsToKeySet(positions: FretPosition[]): Set<string> {
  return new Set(positions.map((p) => `${p.string}-${p.fret}`));
}
